import React from 'react';
import { ArrowRight } from 'mdi-material-ui';

import { LabelEnum, TerminationGeneratorEnum } from 'app/shared/enums';
import { ReactComponent as DocIcon } from 'app/assets/icons/google-doc.svg';
import { ReactComponent as TimeIcon } from 'app/assets/icons/time-quarter.svg';
import { ReactComponent as InternetIcon } from 'app/assets/icons/internet.svg';
import { CompactModal } from 'app/components/CompactModal';
import { NewButton } from 'app/components/NewButton';

import { TerminationGeneratorOnlineRedirectModalProps } from './TerminationGeneratorOnlineRedirectModal.interfaces';
import { useStyles } from './TerminationGeneratorOnlineRedirectModal.styles';

export default function TerminationGeneratorOnlineRedirectModal({
  onRedirect,
  onContinue,
  onClose,
}: TerminationGeneratorOnlineRedirectModalProps) {
  const classes = useStyles();

  return (
    <CompactModal className={classes.modal} onClose={onClose}>
      <div
        className={classes.modalHeading}
        data-cy="termination-generator-online-redirect-modal"
      >
        {TerminationGeneratorEnum.OnlineRedirectModalHeading}
      </div>
      <div className={classes.modalText}>
        {TerminationGeneratorEnum.OnlineRedirectModalText1}
        <br />
        <strong>{TerminationGeneratorEnum.OnlineRedirectModalText2}</strong>
      </div>
      <div className={classes.iconBoxes}>
        <div className={classes.iconBox}>
          <InternetIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.OnlineRedirectModalIconBox1}
          </div>
        </div>
        <div className={classes.iconBox}>
          <DocIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.OnlineRedirectModalIconBox2}
          </div>
        </div>
        <div className={classes.iconBox}>
          <TimeIcon className={classes.iconBoxIcon} />
          <div className={classes.iconBoxText}>
            {TerminationGeneratorEnum.OnlineRedirectModalIconBox3}
          </div>
        </div>
      </div>
      <NewButton
        className={classes.redirectButton}
        variant={'contained'}
        color={'primary'}
        title={TerminationGeneratorEnum.OnlineRedirectModalRedirectButton}
        fullWidth
        onClick={onRedirect}
        suffixIcon={ArrowRight}
        rounded
        size={'large'}
      />
      <div className={classes.separator}>
        <div className={classes.separatorText}>{LabelEnum.Or}</div>
      </div>
      <NewButton
        variant={'text'}
        color={'primary'}
        title={TerminationGeneratorEnum.OnlineRedirectModalContinueButton}
        fullWidth
        onClick={onContinue}
        className={classes.continueButton}
      />
      <div className={classes.modalFooter}>
        {TerminationGeneratorEnum.OnlineRedirectModalFooterText}
      </div>
    </CompactModal>
  );
}
